













import {Vue, Component, Prop } from 'vue-property-decorator';
import TabsItem from './TabsItem';

@Component({
  name: 'Tabs',
  components: {
    TabsItem,
  },
})
export default class Tabs extends Vue {
  @Prop({type: Array, default: () => []}) public readonly list!: [];
  @Prop({type: String, default: ''}) public readonly passClass!: string;
  @Prop({type: String, default: ''}) public readonly passClassItem!: string;
  @Prop({type: Object, default: () => {}}) public readonly mapTabs!: object;

  public get mapped() {
    return this.mapTabs || {};
  }

  public activeTab(tab): boolean {
    return this.$route.name === tab.name || this.mapped[this.$route.name as string] === tab.name;
  }

  public resolvePermission(link) {
    return link?.meta?.hasPermission ?? true;
  }
}
